import {Component, Inject} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {AdService} from '@services/ad.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormService} from '@services/form.service';
import {Router} from '@angular/router';
import {FavoriteList} from '@models/favorite';
import {EMPTY_FAVORITE_LIST} from '@models/empty';
import {AlertService} from '@services/alert.service';

@Component({
    selector: 'app-rename-popup',
    templateUrl: './rename-popup.component.html',
    styleUrls: ['./rename-popup.component.scss']
})
export class RenamePopupComponent {

    favoritesList: FavoriteList = EMPTY_FAVORITE_LIST;
    loading = false;

    favoriteForm = new UntypedFormGroup({
        title: new UntypedFormControl('', []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private adService: AdService,
        public dialogRef: MatDialogRef<RenamePopupComponent>,
        public formService: FormService,
        private alertService: AlertService,
        private router: Router) {

        this.favoritesList = Object.assign({}, data.favoritesList);
        this.favoriteForm.setValue({title: this.favoritesList.title});
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favoriteForm.valid && this.loading == false && this.favoriteForm.get('title').value) {
            this.loading = true
            this.favoritesList.title = this.favoriteForm.get('title').value;
            this.adService.editFavoritesList(this.favoritesList).subscribe(result => {
                this.dialogRef.close(result);
            }, error => {
                this.alertService.error('Une erreur est survenue pendant l\'enregistrement de l\'utilisateur. Veuillez rééssayer ultérieurement.');
                console.log(error);
                this.loading = false;
            });
        }
    }
}
